<div
  class="bg-base-100 text-content flex w-full flex-col items-center rounded-t-xl p-10"
>
  <footer class="footer w-full xl:w-5xl 2xl:w-4/5">
    <aside>
      <img src="/assets/logo/logo.png" class="w-32 lg:w-48" />
      <!-- <p>
        SAR ANLAGENBAU GmbH<br />
        3363 Hausmening<br />
        Bahnhofstraße 34
      </p> -->
    </aside>
    <nav>
      <h6 class="footer-title">
        {{ "navigation.footer.contact" | translate }}
      </h6>
      <a href="mailto:akademie@sar-anlagenbau.at" class="text-content"
        >akademie&#64;sar-anlagenbau.at</a
      >
      <a href="tel:+437475202020" class="text-content">
        +43 (0) 7475 20202-0
      </a>
    </nav>
  </footer>
  <app-version></app-version>
</div>
